<template>
    <div class="mp-drawer">
        <div class="mp-panel">
            <div class="mp-wrap">
                <img src="@/assets/mobile/home/logo_black.png" alt="" class="mp-search-logo" @click="goHome">
                <div class="mp-header">
                    <div class="mp-search">
                       <!-- <input class="mp-search-input" type="text" v-model="searchQuery" @blur="judgeSearchInfo"
                            placeholder="What are you looking for?" @keyup.enter="onSearch" />
                        <button class="mp-search-btn" @click="onSearch" :disabled="searchLoading">[search]</button> -->
						<input 
						    class="mp-search-input" 
						    type="search" 
						    v-model="searchQuery" 
						    @blur="judgeSearchInfo"
						    placeholder="What are you looking for?" 
						    @keyup.enter="onSearch" 
						    enterkeyhint="search" 
						/>
                    </div>
                    <p v-if="showResults" class="mp-search-count">Found {{ searchTotal }} results</p>
                </div>

                <div class="mp-content" @click="closeSearch">
                    <!-- 加载中指示器 -->
                    <div v-if="searchLoading && searchPageIndex === 1" class="loading-indicator">Loading...</div>
                    
                    <!-- 搜索结果网格 -->
                    <div v-else-if="showResults" class="mp-grid">
                        <div v-for="(item, idx) in displayedItems" :key="item.ProductID || idx" class="mp-card" @click="openItem(item)">
                            <ProgressiveImage :src="item.image || defaultImage" :alt="item.name" customClass="mp-thumb" />
                        </div>
                    </div>
                    
                    <!-- 默认产品浏览模式（非搜索状态） -->
                    <div v-else ref="sentinel" class="mp-sentinel"></div>
                    
                    <!-- 加载更多指示器 -->
                    <div v-if="searchLoading && searchPageIndex > 1" class="loading-more">Loading more...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressiveImage from '@/components/ProgressiveImage.vue'
import { searchProducts } from '@/api/product'
import { showMessage } from '@/config/message'

 

export default {
    name: 'MobileSearch',
    components: {
        ProgressiveImage
    },
    props: {
        // 可选：初始分类（原组件保留，但搜索时忽略）
        section: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            searchQuery: '',
            showResults: false,
            searchLoading: false,
            searchPageIndex: 1,
            searchTotal: 0,
            searchHasMore: true,
            searchResults: [],          // 当前已加载的搜索结果
            defaultImage:'',
            // 以下为原默认产品浏览模式的数据（非搜索时展示）
            observer: null,
            allItems: [],
            visibleItems: [],
            page: 0,
            pageSize: 4
        }
    },
    computed: {
        // 当前显示的条目：搜索模式显示搜索结果，否则显示默认产品浏览
        displayedItems() {
            return this.showResults ? this.searchResults : this.visibleItems
        }
    },
    mounted() {
        // 初始化默认产品浏览（非搜索模式）
        this.resetAndLoad()
        this.initObserver()
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
    },
    methods: {
        goHome() {
            this.$emit('close')
            setTimeout(() => {
                this.$router.push('/m')
            }, 300)
        },
        judgeSearchInfo() {
            if (!this.searchQuery.trim()) {
                this.showResults = false
                // 清空搜索结果
                this.searchResults = []
                this.searchPageIndex = 1
                this.searchTotal = 0
            }
        },
        async onSearch() {
            const keyword = this.searchQuery.trim()
            if (!keyword) {
                showMessage('Please enter a keyword', 'error')
                return
            }
            // 重置搜索状态
            this.showResults = true
            this.searchResults = []
            this.searchPageIndex = 1
            this.searchHasMore = true
            this.searchLoading = true

            await this.fetchSearchResults(keyword, 1)
        },
        async fetchSearchResults(keyword, pageIndex) {
            try {
                const response = await searchProducts({
                    keyword,
                    pageIndex,
                    pageSize: 20  // 每页20条
                })
                if (response.retCode === 1) {
                    const products = response.result || []
                    const total = response.totalCount || 0
                    
                    // 格式化数据
                    const formatted = products.map(p => ({
                        ProductID: p.ProductID,
                        name: p.ProductName,
                        image: p.Images.find(img => img.IsPrimary).ImageURL || p.Images[0].ImageURL || ''
                    }))

                    if (pageIndex === 1) {
                        this.searchResults = formatted
                    } else {
                        this.searchResults = [...this.searchResults, ...formatted]
                    }

                    this.searchTotal = total
                    this.searchHasMore = this.searchResults.length < total
                    this.searchPageIndex = pageIndex
                } else {
                    showMessage(response.retMsg || 'Search failed', 'error')
                }
            } catch (error) {
                console.error('Search error:', error)
                showMessage('Network error, please try again', 'error')
            } finally {
                this.searchLoading = false
            }
        },
        // 滚动加载更多（仅在搜索模式下有效）
        async loadMore() {
            if (!this.showResults || this.searchLoading || !this.searchHasMore) return
            const nextPage = this.searchPageIndex + 1
            await this.fetchSearchResults(this.searchQuery.trim(), nextPage)
        },
        // 监听滚动
        onIntersect(entries) {
            if (this.showResults) return // 搜索模式下的加载由独立的滚动监听处理
            const entry = entries[0]
            if (entry && entry.isIntersecting) {
                this.loadDefaultMore()
            }
        },
        // 默认产品浏览的加载更多（非搜索模式）
        loadDefaultMore() {
            if (this.page * this.pageSize >= this.allItems.length) return
            const start = this.page * this.pageSize
            const end = start + this.pageSize
            this.visibleItems = this.visibleItems.concat(this.allItems.slice(start, end))
            this.page += 1
        },
        // 构建默认产品数据（与原有逻辑一致）
        buildAllItems() {
            let base = []
            if (this.section === 'seating') {
                base = [
                    { img: require('@/assets/mobile/product/Rectangle 81.png'), title: 'Chair' },
                    { img: require('@/assets/mobile/product/Rectangle 85.png'), title: 'Stool' }
                ]
            } else if (this.section === 'accessories') {
                base = [
                    { img: require('@/assets/mobile/product/TGT-Melissa-Marshall-27 2.png'), title: 'Planter' },
                    { img: require('@/assets/mobile/product/Rectangle 82.png'), title: 'Lighting' },
                    { img: require('@/assets/mobile/product/Rectangle 81.png'), title: 'Mirror' },
                    { img: require('@/assets/mobile/product/Rectangle 85.png'), title: 'Hardware' }
                ]
            } else {
                base = [
                    { img: require('@/assets/mobile/product/TGT-Melissa-Marshall-27 2.png'), title: 'Entry Table' },
                    { img: require('@/assets/mobile/product/Rectangle 82.png'), title: 'Console Table' },
                    { img: require('@/assets/mobile/product/Rectangle 81.png'), title: 'Coffee Table' },
                    { img: require('@/assets/mobile/product/Rectangle 85.png'), title: 'Side Table' }
                ]
            }
            // 重复多次以模拟更多数据
            const times = 5
            this.allItems = []
            for (let i = 0; i < times; i++) {
                this.allItems = this.allItems.concat(base.map(b => ({ ...b })))
            }
        },
        resetAndLoad() {
            this.page = 0
            this.visibleItems = []
            this.buildAllItems()
            this.loadDefaultMore()
        },
        initObserver() {
            const root = this.$el.closest('.mp-content') || null
            this.observer = new IntersectionObserver(this.onIntersect, {
                root,
                threshold: 0.1
            })
            if (this.$refs.sentinel) {
                this.observer.observe(this.$refs.sentinel)
            }
        },
        openItem(item) {
            // 跳转到产品详情页，携带 productId
            this.$router.push(`/m/product/${item.ProductID || 17}`)
            this.$emit('close')
        },
        closeSearch() {
            if (this.showResults) return
            this.$emit('close')
        }
    },
    watch: {
        // 监听滚动加载（需要在模板中实现）
        // 由于我们没有在模板中监听滚动事件，可以通过在 mp-content 上添加 @scroll 来实现
        // 但在本组件中，我们已在模板中为 mp-content 添加了 @click，滚动事件需要额外添加
        // 我们将在模板中补充 @scroll 监听
    }
}
</script>

<style scoped>
.mp-wrap {
    display: flex;
    flex-direction: column;
    font-family: 'Apercu', sans-serif;
    min-height: 0;
    height: 100%;
    width: 100%;
}
.mp-drawer {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.mp-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
}
.mp-header {
    position: sticky;
    z-index: 2;
    background: #fff;
    padding: 97rem 68rem 28rem;
}
.mp-content {
    flex: 1;
    min-height: 0;
    background: transparent !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain !important;
}
.mp-search {
    display: flex;
    align-items: center;
    gap: 12rem;
    border-bottom: 1rem solid #000;
}
.mp-search-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 16px;      /* 关键：从 14px 改为 16px */
    font-weight: 400;
    color: #000;
    padding: 0 0 8rem;
    background: transparent;
    font-family: 'Apercu Pro', sans-serif;
}
.mp-search-input::placeholder {
    color: #999;
}
/* 确保搜索框字体 ≥16px */
.mp-search-input {
    font-size: 16px;            /* 已存在 */
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
}

/* 针对聚焦时的额外保险 */
.mp-search-input:focus {
    font-size: 16px;
}
.mp-search-btn {
    background: none;
    border: none;
    padding: 0;
    font-size: 16rem;
    font-weight: 500;
    letter-spacing: 1rem;
    color: #000;
    height: 100%;
    cursor: pointer;
}
.mp-search-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.mp-search-count {
    font-size: 12rem;
    color: #999;
    margin: 10rem 0 10rem;
}
.mp-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.mp-card {
    display: flex;
    flex-direction: column;
}
.mp-thumb {
    object-fit: cover;
    width: 100%;
    height: 245rem;
}
.mp-title {
    font-size: 13rem;
    color: #000;
}
.mp-sentinel {
    width: 100%;
    height: 1rem;
}
.mp-search-logo {
    background: #fff;
    z-index: 999;
    cursor: pointer;
}
.loading-indicator,
.loading-more {
    text-align: center;
    padding: 20rem;
    font-size: 14rem;
    color: #666;
}
</style>
